var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextDifficulty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84219 3.32031C3.2364 3.32031 2.74219 3.81453 2.74219 4.42031V5.93031C2.74219 6.34453 2.4064 6.68031 1.99219 6.68031C1.57797 6.68031 1.24219 6.34453 1.24219 5.93031V4.42031C1.24219 2.9861 2.40797 1.82031 3.84219 1.82031H16.7622C18.1964 1.82031 19.3622 2.9861 19.3622 4.42031V5.93031C19.3622 6.34453 19.0264 6.68031 18.6122 6.68031C18.198 6.68031 17.8622 6.34453 17.8622 5.93031V4.42031C17.8622 3.81453 17.368 3.32031 16.7622 3.32031H3.84219Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3047 2.57031C10.7189 2.57031 11.0547 2.9061 11.0547 3.32031V18.1003C11.0547 18.5145 10.7189 18.8503 10.3047 18.8503C9.89047 18.8503 9.55469 18.5145 9.55469 18.1003V3.32031C9.55469 2.9061 9.89047 2.57031 10.3047 2.57031Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14844 18.1006C6.14844 17.6864 6.48422 17.3506 6.89844 17.3506H12.4784C12.8927 17.3506 13.2284 17.6864 13.2284 18.1006C13.2284 18.5148 12.8927 18.8506 12.4784 18.8506H6.89844C6.48422 18.8506 6.14844 18.5148 6.14844 18.1006Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4297 14.2292C24.3013 13.8267 23.963 13.5408 23.543 13.4825L20.8247 13.08L19.6113 10.6125C19.4247 10.2333 19.0513 10 18.6255 10C18.2055 10 17.8263 10.2333 17.6397 10.6125L16.4147 13.0742L13.6905 13.465C13.2763 13.5233 12.9322 13.8092 12.8038 14.2117C12.6755 14.6142 12.7805 15.04 13.078 15.3375L15.0438 17.2625L14.5713 19.9692C14.5013 20.3833 14.6647 20.7975 15.003 21.0425C15.3413 21.2933 15.7847 21.3225 16.158 21.13L18.5963 19.8583L21.0288 21.1417C21.1922 21.2292 21.3672 21.27 21.5422 21.27C21.7697 21.27 21.9913 21.2 22.1838 21.06C22.5222 20.815 22.6913 20.4008 22.6213 19.9867L22.1605 17.2742L24.1322 15.3608C24.4355 15.0692 24.5405 14.6375 24.4122 14.235L24.4297 14.2292Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDifficulty);
export default __webpack_public_path__ + "static/media/textDifficulty.b374def5.svg";
export { ForwardRef as ReactComponent };